import { render } from "./LoadingSpinner.vue?vue&type=template&id=546e2c20&scoped=true&ts=true"
import script from "./LoadingSpinner.vue?vue&type=script&lang=ts"
export * from "./LoadingSpinner.vue?vue&type=script&lang=ts"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=546e2c20&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546e2c20"]])

export default __exports__